import { Row, Col, Typography, Select } from "antd";

const { Text } = Typography;

const rowStyle = { marginTop: 12 };

const CtaInfoSection = ({
  cta,
  platforms,
  platformValue,
  brands,
  brandValue,
  onPlatformChange,
  onBrandChange
}) => {
  return (
    <>
      <Row gutter={[16, 16]} align="middle" style={rowStyle}>
        <Col span={4}>
          <Text>CTA:</Text>
        </Col>
        <Col span={8}>
          <Text>{cta || "-"}</Text>
        </Col>
      </Row>

      <Row gutter={[16, 16]} align="middle" style={rowStyle}>
        <Col span={4}>
          <Text>Platform:</Text>
        </Col>
        <Col span={8}>
          <Select
            style={{ width: "100%" }}
            value={platformValue || undefined}
            onChange={onPlatformChange}
            options={platforms}
            placeholder="Please select a platform"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} align="middle" style={rowStyle}>
        <Col span={4}>
          <Text>Client/Brand:</Text>
        </Col>
        <Col span={8}>
          <Select
            style={{ width: "100%" }}
            value={brandValue || undefined}
            onChange={onBrandChange}
            options={brands}
            placeholder="Please select a brand"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default CtaInfoSection;